/**
 * @fileOverview Z Axis
 */
function ZAxis(props) {
  return null;
}

ZAxis.displayName = 'ZAxis';
ZAxis.defaultProps = {
  zAxisId: 0,
  range: [64, 64],
  scale: 'auto',
  type: 'number'
};
export default ZAxis;